import React from "react";
import { trackProductEvent } from "./productAnalytics";

export default class AppErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }

  static getDerivedStateFromError(error) {
    return { error };
  }

  componentDidCatch(error, info) {
    console.error("Venaqqi UI error", error, info);
    void trackProductEvent("client_error", {
      source: "react_boundary",
      error_name: String(error?.name || error?.constructor?.name || "Error").slice(0, 80),
      severity: "error",
    });
  }

  render() {
    if (!this.state.error) return this.props.children;
    return (
      <main role="alert" style={{ minHeight: "100vh", background: "#080808", color: "#fff", display: "grid", placeItems: "center", padding: 24, fontFamily: "Arial,sans-serif" }}>
        <section style={{ width: "min(420px,100%)", background: "#111", border: "1px solid #2a2a2a", borderRadius: 18, padding: 22, textAlign: "center" }}>
          <div aria-hidden="true" style={{ fontSize: 34 }}>★</div>
          <h1 style={{ fontSize: 18, margin: "10px 0 8px" }}>Venaqqi sigue aquí</h1>
          <p style={{ color: "#aaa", fontSize: 13, lineHeight: 1.5 }}>Algo no pudo mostrarse correctamente. Recupera la pantalla sin perder tu cuenta.</p>
          <button onClick={() => window.location.reload()} style={{ width: "100%", marginTop: 12, padding: 12, border: 0, borderRadius: 10, background: "#e53935", color: "white", fontWeight: 800, cursor: "pointer" }}>Recuperar Venaqqi</button>
        </section>
      </main>
    );
  }
}
